import { type FC } from "react";

import { NewCaseInline } from "./new_case_inline";

// The cases list with no cases at all — the tail points into the real New Case
// form, and the Records/Reports/Dictation bubbles belong to a case, so they
// aren't shown.
export const GuidedListEmptyState: FC = () => (
  <div className="py-6">
    <h2 className="text-[17px] font-bold text-slate-900">
      You don&apos;t have any cases yet.
    </h2>
    <p className="mt-0.5 text-[12px] text-slate-500">
      Cases assigned to you will appear here. You can also start one yourself.
    </p>

    <NewCaseInline tag="Start here" />
  </div>
);
